import styled from '@emotion/styled';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
